import axios from "axios"
import jwtDecode from "jwt-decode";
import accessToken from './jwt-token-access/accessToken';
import refreshToken from "./jwt-token-access/refreshToken";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
      
    } else {
      prom.resolve(token);
    }
  })
  
  failedQueue = [];
}

const API_URL = process.env.REACT_APP_API_URL;

const axiosApi = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
})

axiosApi.interceptors.request.use(
    config => {
        const token = accessToken();
        console.log("Interceptor :: ")
        if(token){
          config.headers["authorization"] = token;
        }
        config.data = {...config.data};
        return config;
    },
    error => Promise.reject(error)
)

export async function get(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then(response => ({...response.data, status: response.status})).catch(err => err);
}

export async function getBodyOnly(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then(response => ({...response.data})).catch(err => err);
}

export async function post(url, data, config = {}) {
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then(response => response.data)
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then(response => response.data)
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then(response => response.data)
}

export const setupInterceptors = history => {
    axiosApi.interceptors.response.use(res => {

    return res
  }, err => {
    try {

      const { status } = err.response;
      const originalRequest = err.config;
      const refToken = refreshToken();
      const acc = accessToken();
      const user = jwtDecode(acc);
      const name = user["email"];
      if (status === 401 && !originalRequest._retry && refToken && refToken !== "" ) {
        console.log("is Refrereshing :: ", isRefreshing)
        if(isRefreshing){
          history.push('/sessionExpired')
          return new Promise(function(resolve,reject){
            failedQueue.push({resolve, reject})
          }).then(token => {originalRequest.headers['authorization'] = token;
          return axiosApi(originalRequest);
        }).catch(err =>{
          console.log("Error in inside Catch :: ", err)
          history.push('/sessionExpired')
          return Promise.reject(err)
        })
        }
          originalRequest._retry = true;
          isRefreshing = true;

          return new Promise(function (resolve, reject) {
              axiosApi.post('/refresh', {
              "refreshToken": refToken,
              "username": name
            }).then(res => {
              isRefreshing = false;
              localStorage.setItem("authUser", JSON.stringify(res.data));
              processQueue(null, res.data.idToken)
              resolve(axiosApi(originalRequest));

            })
            .catch((err) => {
              // history.push('/sessionExpired');
              console.log("suh", err)
              processQueue(err, null);
              reject(err)
              history.push('/sessionExpired')
              // return Promise.reject(err);
            }).finally(() => {isRefreshing = false})
          })
          
      }
      else{
        if(status === 401){
          history.push('/sessionExpired')
        }
      } 

      return Promise.reject(err)
    } catch (e) {
      return Promise.reject(err)
    }
  })
}

export default axiosApi